var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showDing)?_c('div',{staticClass:"ding-open-wrap"},[_c('span',[_vm._v("复制链接到浏览器打开")]),_c('span',{staticClass:"btn",on:{"click":function($event){return _vm.handleCopy(_vm.url)}}},[_vm._v("复制")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }